import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/LoginView.vue'
import TheMain from '@/layouts/TheMain.vue'
import PlayList from '@/views/playlist/PlayListView.vue';
import Dashboard from '@/views/dashboard/Dashboard.vue';
// import LiveManual from '@/views/dashboard/LiveManual.vue';
// import VodManual from '@/views/dashboard/VodManual.vue';
import PAGE404 from '@/pages/404.vue';
import PAGEMedia from '@/pages/MediaError.vue';
import PlayerStyle from '@/components/player/Player-style.vue';
import UploadOption from '@/views/user/UploadOptionView.vue';
import PlayerOption from '@/views/user/PlayerOptionView.vue';
import EncodingList from '@/views/encoding/EncodingListView.vue';
import EncodingCreate from '@/components/encoding/EncodingCreate.vue';
import CdnList from '@/views/cdn/CdnListView.vue';
import CdnCreate from '@/components/cdn/CdnCreate.vue';
import CdnInfo from '@/components/cdn/CdnInfo.vue';
import CertList from '@/views/cert/CertListView.vue';
import CertImport from '@/components/cert/CertImport.vue';
import CertTag from '@/components/cert/CertTag.vue';
import UserView from '@/views/user/UserInfoView.vue';

import UserCreate from '@/components/user/UserCreate.vue';
import WowzaList from '@/views/wowza/WowzaListView.vue';
import WowzaCreate from '@/components/wowza/WowzaCreate.vue';
import Template from '@/views/template/TemplateView.vue';
import AssetModify from '@/views/Asset/Asset-Modify.vue';
import Admin from '@/components/user/AdminForm.vue';
import Guest from '@/components/user/GuestForm.vue';

import WowzaLivestreamCreate from '@/views/wowzalivestream/WowzaLivestreamCreate.vue';
import WowzaLivestreamView from '@/components/livestream/WowzaLivestreamViewForm.vue';
import WowzaLivePullstreamView from '@/components/livestream/WowzaLivePullstreamViewForm.vue';
import WowzaLivestreamRecording from '@/views/wowzalivestream/WowzaLivestreamRecording.vue';
import Statistics from '@/views/statistics/StatisticsView.vue';
import LiveStatistics from '@/views/statistics/LiveStatisticsView.vue';
import VodStatistics from '@/views/statistics/VodStatisticsView.vue';
import PasswordReset from '@/views/user/PasswordReset.vue';
import SocialUpload from '@/components/socialupload/SocialUploadForm.vue';
import socialConnected from '@/components/socialupload/SocialConnected.vue';
import GoogleCallback from '@/components/socialupload/GoogleCallback.vue';

import Player from '@/components/player/player.vue';
// import Playertest from '@/components/player/Playtest.vue';
import Play from '@/components/player/Play.vue';
// import Playertest3 from '@/components/player/Playtest3.vue';
// import Playertest4 from '@/components/player/Playtest4.vue';

import store from '@/store';
import '../styles/font/font.css';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: TheMain,
    children: [
      {
        path: '',
        name: 'Login',
        component: Login,
      },
      {
        path: '/asset',
        name: 'asset',
        component: () => import('../views/Asset/Asset.vue'),
      },
      {
        path: '/asset-modify',
        name: 'asset-modify',
        component: AssetModify,
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
      },
      {
        path: 'playlist',
        name: 'playlist',
        component: PlayList,
      },
      {
        path: '/statistics',
        name: 'statistics',
        component: Statistics,
      },
      {
        path: '/admin/user',
        name: 'user',
        component: UserView,
        
      },
      // {
      //   path: '/admin/user/:username',
      //   name: 'user-details',
      //   component: Guest,
      //   beforeEnter: (to, from, next) => {
      //     // store.dispatch('user/adminCheck').then(() => {
      //     const loggedInUser = store.getters['user/username'];
      //     //console.log('log', loggedInUser);
      //     if (loggedInUser !== 'kcinfra' && loggedInUser === to.params.username) {
      //       next();
      //     } else {
      //       //next('/');
      //     }
      //     // })
      //   },
      // },
      {
        path: '/admin/user_details/:userId',
        name: 'admin-user-details',
        component: Admin,
        beforeEnter: (to, from, next) => {
          store.dispatch('user/adminCheck').then(() => {
            const userStatus = store.getters['user/userStatus'];
            if (userStatus === 'admin') {
              next();
            } else if (userStatus === 'guest') {
              next('/dashboard');
            } else {
              next('/');
            }
          });
        },
      },
      {
        path: '/admin/user_create',
        name: 'user_create',
        component: UserCreate,
        beforeEnter: (to, from, next) => {
          store.dispatch('user/adminCheck').then(() => {
            const userStatus = store.getters['user/userStatus'];
            if (userStatus === 'admin') {
              next();
            } else if (userStatus === 'guest') {
              next('/dashboard');
            } else {
              next('/');
            }
          });
        },
      },
      {
        path: '/upload/option',
        name: 'Upload-option',
        component: UploadOption
      },
      {
        path: '/cms-setting',
        name: 'PlayerOption',
        component: PlayerOption
      },
      {
        path: '/admin/encodingservers_list',
        name: 'encodingservers_list',
        component: EncodingList
      },
      {
        path: '/admin/encodingservers_create',
        name: 'encodingservers_create',
        component: EncodingCreate
      },
      {
        path: '/template',
        name: 'template',
        component: Template
      },
      {
        path: '/cdn',
        name: 'cdn',
        component: CdnList,
      },
      {
        path: '/cdn/info',
        name: 'cdn_info',
        component: CdnInfo,
      },
      {
        path: '/cdn/create_wowzaserver',
        name: 'cdncreate_wowzaserver',
        component: CdnCreate
      },
      {
        path: '/cert/cert_list',
        name: 'cert_list',
        component: CertList
      },
      {
        path: '/cert/cert_import',
        name: 'cert_list',
        component: CertImport
      },
      {
        path: '/cert/cert_tags',
        name: 'cert_tags',
        component: CertTag
      },
      {
        path: '/wowza/wowzaservers_list',
        name: 'wowzaservers_list',
        component: WowzaList
      },
      {
        path: '/wowza/wowzaservers_create',
        name: 'wowzaservers_create',
        component: WowzaCreate
      },
      {
        path: '/wowzastream/wowzalivestream_create',
        name: 'wowzalivestream_create',
        component: WowzaLivestreamCreate
      },
      {
        path: '/wowzastream/wowzalivestream_recording',
        name: 'wowzalivestream_recording',
        component: WowzaLivestreamRecording
      },
      {
        path: '/wowzastream/wowzalivestream_view/:uuid',
        name: 'wowzalivestream_view',
        component: WowzaLivestreamView
      },
      {
        path: '/wowzastream/wowzalivepullstream_view/:uuid',
        name: 'wowzalivepullstream_view',
        component: WowzaLivePullstreamView
      },
      {
        path: '/live-statistics',
        name: 'livestatistics',
        component: LiveStatistics
      },
      {
        path: '/vod-statistics',
        name: 'vodstatistics',
        component: VodStatistics
      },
      {
        path: '/social-upload',
        name: 'socialupload',
        component: SocialUpload
      },
      {
        path: '/social-Connected',
        name: 'socialConnected',
        component: socialConnected
      },
      {
        path: '/password/reset',
        beforeEnter(to, from, next) {
          if (!to.query.token || !to.query.email) {
            next('/');
          } else {
            next('/password/reset/' + to.query.token);
          }
        }
      },
      {
        path: '/password/reset/:token',
        name: 'passwordreset',
        component: PasswordReset,
      },
      {
        path: '/auth/callback',
        name: 'GoogleCallback',
        component: GoogleCallback,
      },
    ]
  },
  {
    path: '/vod-manual',
    name: 'vod-manual',
    component: () => import('../views/manual/Vod_Manual.vue'),
  },
  {
    path: '/live-manual',
    name: 'live-manual',
    component: () => import('../views/manual/LiveManual.vue'),
  },
  {
    path: '/404',
    name: '404pages',
    component: PAGE404,
  },
  {
    path: '/mediaerror',
    name: 'PAGEMedia',
    component: PAGEMedia,
  },
  // {
  //   path: '/password/reset',
  //   beforeEnter(to, from, next) {
  //     if (!to.query.token || !to.query.email) {
  //       next('/');
  //     } else {
  //       next('/password/reset/' + to.query.token);
  //     }
  //   }
  // },
  {
    path: '/player',
    name: 'player',
    //component: PlayerStyle,
    component: Player,
  },
  // {
  //   path: '/playtest',
  //   name: 'player',
  //   //component: PlayerStyle,
  //   component: Playertest,
  // },
  {
    path: '/play',
    name: 'Play',
    component: Play,
  },
  {
    path: '*',
    redirect: '/'
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {


  if (to.path === '/player') {
    return next();
  }

  if (to.path === '/play') {
    return next();
  }

  if (to.path === '/vod-manual') {
    return next();
  }
  if (to.path === '/live-manual') {
    return next();
  }


  store.dispatch('user/checkAuth').then(() => {
    const isLoggedIn = store.getters['user/isLoggedIn'];

    if (isLoggedIn && (to.path === '/')) {
      next('/dashboard');
    } else if (!isLoggedIn && to.path !== '/') {
      next('/');
    } else {
      next();
    }

    if (to && to.name === 'asset') {
      store.dispatch('asset/updateDrawer', false);
    }

  });
});

router.beforeEach((to, from, next) => {
  store.dispatch('search/resetSearch');
  next();
});


// router.beforeEach((to, from, next) => {
//   store.dispatch('user/checkAuth').then(() => {
//     const isLoggedIn = store.getters['user/isLoggedIn'];

//     if (isLoggedIn) {
//       if (to.path === '/' && from.path !== '/dashboard') {
//         next('/dashboard');
//       } else if (to.path === '/dashboard' && from.path === '/') {
//         next();
//       } else {
//         store.dispatch('naviList/list').then(() => {
//           const menuItems = store.getters['naviList/menuItems'];
//           console.log('menu', menuItems);
//           const validPath = menuItems.some(item => item.to === to.path);
//           console.log('valid', validPath);
//           if (!validPath && to.path !== '/404') {
//             next('/404');
//           } else {
//             next();
//           }
//         });
//       }
//     } else {
//       if (to.path !== '/') {
//         next('/');
//       } else {
//         next();
//       }
//     }
//   });
// });








export default router
